import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { useParams, Link } from "react-router-dom";
import { deleteStatus, gettokendata } from '../../actions/users';
import { useDispatch } from "react-redux";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import { Navigate, useNavigate } from 'react-router-dom';

const initialFormValue = {
    image: "",
    swapPrice: 0,
    tokenDesc: "",
    tokenPrice: 0,
    tokenCategory: "",
    likecount: 0,
    hashValue: "",
    status: "",
    tokenQuantity: 0,
    balance: 0,
    contractAddress: "",
    type: 721,
    minimumBid: 0,
    endclocktime: null,
    clocktime: null,
    unlockcontent: "",
    counts: 0,
    PutOnSale: true,
    PutOnSaleType: "",
    ipfsimage: "",
    tokenID: 0,
    tokenName: "",
    tokenRoyality: 0,
    tokenBid: true,
    tokenOwner: "",
    tokenCreator: "",
    timestamp: null,
};

const ViewToken = () => {

  const navigate = useNavigate()
  const [formValue, setFormValue] = useState(initialFormValue);
  const [noofitems, setnoofitemss] = useState(0);

  const [token_price, set_token_price] = useState(0);
  const [token_balance, set_token_balance] = useState(0);
  const [token_owner, set_token_owner] = useState("");

  const [deleted, setdeleted] = useState(0);
  const { Owner, Id } = useParams();

    useEffect(() => {
        getTokenData();
      }, []);

    const getTokenData = async () => {
        var reqdata = {
          tokenID: Id,
          tokenOwner: Owner,
        };
        var test = await gettokendata(reqdata);
        if (test.Success) {
          if (test.userValue.length > 0) {
            let formdata = {};
            formdata["image"] = test.userValue[0].image;
            formdata["swapPrice"] = test.userValue[0].swapPrice;
            formdata["tokenDesc"] = test.userValue[0].tokenDesc;
            if (
              test.userValue[0].tokenOwnerDb &&
              test.userValue[0].tokenOwnerDb.tokenPrice
            ) {
              formdata["tokenPrice"] = test.userValue[0].tokenOwnerDb.tokenPrice;
              set_token_price(test.userValue[0].tokenOwnerDb.tokenPrice);
            } else {
              formdata["tokenPrice"] = test.userValue[0].tokenPrice;
              set_token_price(test.userValue[0].tokenPrice);
            }
            formdata["likecount"] = test.userValue[0].likecount;
            formdata["tokenCategory"] = test.userValue[0].tokenCategory;
            formdata["hashValue"] = test.userValue[0].hashValue;
            formdata["status"] = test.userValue[0].status;
            setdeleted(test.userValue[0].tokenOwnerDb.deleted);
            formdata["tokenQuantity"] = test.userValue[0].tokenQuantity;
            formdata["balance"] = test.userValue[0].tokenOwnerDb.balance;
            setnoofitemss(test.userValue[0].tokenOwnerDb.balance);
            set_token_balance(test.userValue[0].tokenOwnerDb.balance);
            formdata["contractAddress"] = test.userValue[0].contractAddress;
            formdata["type"] = test.userValue[0].type;
            formdata["minimumBid"] = test.userValue[0].minimumBid;
            formdata["endclocktime"] = test.userValue[0].endclocktime;
            formdata["clocktime"] = test.userValue[0].clocktime;
            formdata["unlockcontent"] = test.userValue[0].unlockcontent;
            formdata["counts"] = test.userValue[0].counts;
            formdata["PutOnSale"] = test.userValue[0].PutOnSale;
            formdata["PutOnSaleType"] = test.userValue[0].PutOnSaleType;
            formdata["ipfsimage"] = test.userValue[0].ipfsimage;
            formdata["tokenID"] = test.userValue[0].tokenID;
            formdata["tokenName"] = test.userValue[0].tokenName;
            formdata["tokenRoyality"] = test.userValue[0].tokenRoyality;
            formdata["tokenBid"] = test.userValue[0].tokenBid;
            formdata["tokenOwner"] = test.userValue[0].tokenOwnerDb.tokenOwner;
            set_token_owner(test.userValue[0].tokenOwnerDb.tokenOwner);
            formdata["tokenCreator"] = test.userValue[0].tokenCreator;
            formdata["timestamp"] = test.userValue[0].tokenOwnerDb.timestamp;
            setFormValue(formdata);
          } else {
            toastAlert("error", "Token Not Found");
          }
        } else {
          toastAlert("error", "Error in Server");
        }
    };

    const hideshow = async (deleted) => {
        if (deleted) {
          var postdata = {
            deleted: 0,
            tokenID: tokenID,
            tokenOwner: tokenOwner,
          };
        } else {
          var postdata = {
            deleted: 1,
            tokenID: tokenID,
            tokenOwner: tokenOwner,
          };
        }
        var resp = await deleteStatus(postdata);
        if (resp.Success) {
          toastAlert("success", resp.Message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
        else{
            toastAlert("success", resp.Message);
        }
      };

    const {
        tokenDesc,
        tokenPrice,
        tokenCategory,
        hashValue,
        status,
        tokenQuantity,
        balance,
        contractAddress,
        type,
        minimumBid,
        endclocktime,
        clocktime,
        tokenProperty,
        tokenID,
        tokenName,
        tokenRoyality,
        tokenBid,
        tokenOwner,
        tokenCreator,
        timestamp,
      } = formValue;

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'View Token'} />
                        <div className='common_page_scroller mt-5 pe-2'>
                        <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>
                            <form>
                              <div color="primary" className="addcategorys">
                                    <h4>View Token</h4>
                                </div>

                                <div className="categorylisdt">
                                <div className='row'>
                                <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenID">Token ID</label>
                                        <input type="text" className='form-control' id="tokenID" value={tokenID || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenName">Token Name</label>
                                        <input type="text" className='form-control' id="tokenName" value={tokenName || ""} disabled fullWidth />
                                    </div>
                                    {tokenDesc !== undefined && tokenDesc !== "" && (
                                        <div className='col-xl-5 mt-4'>
                                            <label htmlFor="tokenDesc">Token Description</label>
                                            <input type="text" className='form-control' id="tokenDesc" value={tokenDesc || ""} disabled fullWidth />
                                        </div>
                                    )}
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenBid">Token Bid</label>
                                        <input type="text" className='form-control' id="tokenBid" value={tokenBid || ""} disabled fullWidth />
                                    </div>
                                    {clocktime == null && endclocktime == null && tokenPrice != 0 && (
                                        <div className='col-xl-5 mt-4'>
                                            <label htmlFor="tokenPrice">Token Price</label>
                                            <input type="text" className='form-control' id="tokenPrice" value={token_price || ""} disabled fullWidth />
                                        </div>
                                    )}
                                    {clocktime != null && endclocktime != null && (
                                        <>
                                            <div className='col-xl-5 mt-4'>
                                                <label htmlFor="clocktime">Starting Time</label>
                                                <input type="text" className='form-control' id="clocktime" value={clocktime || ""} disabled fullWidth />
                                            </div>
                                            <div className='col-xl-5 mt-4'>
                                                <label htmlFor="endclocktime">Ending Time</label>
                                                <input type="text" className='form-control' id="endclocktime" value={endclocktime || ""} disabled fullWidth />
                                            </div>
                                            <div className='col-xl-5 mt-4'>
                                                <label htmlFor="minimumBid">Minimum Bid</label>
                                                <input type="text" className='form-control' id="minimumBid" value={minimumBid || ""} disabled fullWidth />
                                            </div>
                                        </>
                                    )}
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenRoyality">Token Royalty (in Percentage)</label>
                                        <input type="text" className='form-control' id="tokenRoyality" value={tokenRoyality || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenQuantity">Token Total Quantity</label>
                                        <input type="text" className='form-control' id="tokenQuantity" value={tokenQuantity || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="balance">Token Available Quantity (balance)</label>
                                        <input type="text" className='form-control' id="balance" value={token_balance || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenCategory">Token Category</label>
                                        <input type="text" className='form-control' id="tokenCategory" value={tokenCategory || ""} disabled fullWidth />
                                    </div>
                                    {tokenProperty !== undefined && tokenProperty !== "" && (
                                        <div className='col-xl-5 mt-4'>
                                            <label htmlFor="tokenProperty">Token Property</label>
                                            <input type="text" className='form-control' id="tokenProperty" value={tokenProperty} disabled fullWidth />
                                        </div>
                                    )}
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenCreator">Token Creator</label>
                                        <input type="text" className='form-control' id="tokenCreator" value={tokenCreator || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="tokenOwner">Token Owner</label>
                                        <input type="text" className='form-control' id="tokenOwner" value={token_owner || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="contractAddress">Contract Address</label>
                                        <input type="text" className='form-control' id="contractAddress" value={contractAddress || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="type">Token Type</label>
                                        <input type="text" className='form-control' id="type" value={type || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="status">Token Status</label>
                                        <input type="text" className='form-control' id="status" value={status} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="hashValue">Token Hash Value</label>
                                        <input type="text" className='form-control' id="hashValue" value={hashValue || ""} disabled fullWidth />
                                    </div>
                                    <div className='col-xl-5 mt-4'>
                                        <label htmlFor="timestamp">Created At</label>
                                        <input type="text" className='form-control' id="timestamp" value={timestamp || ""} disabled fullWidth />
                                    </div>
                                <div className="viewrokens d-flex gap-3 mt-5">
                                    <button type='button' className='btn addcate px-2 py-2 mb-0' color="primary" onClick={() => hideshow(deleted)}>
                                        {deleted == 1 ? "Hide in Marketplace" : "Show in Marketplace"}
                                    </button>
                                    <a href={`${config.IPFS_IMG}/${formValue.ipfsimage}`} target="_blank" className='rounded-3 px-2 py-2 mb-0' color="primary">
                                        View on IPFS
                                    </a>
                                </div>
                                </div>
                                </div>
                            </form>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ViewToken